import { useMediaQuery, Container } from "@mui/material";
import { makeStyles } from "@mui/styles";

import React from "react";
import Header from "../components/ui/header";
import MobileHeader from "../components/ui/mobileHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}));

const Layout = (props) => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      {isMobile ? <MobileHeader /> : <Header />}
      <Container className={classes.root}>{props.children}</Container>
    </>
  );
};

export default Layout;
